import React from 'react';
import { MDXProvider } from '@mdx-js/react';

import components from './index';

const CustomMDXProvider = ({ children }) => {
	return <MDXProvider components={{ ...components }}>{children}</MDXProvider>;
};

export default CustomMDXProvider;
